import { AppsLink } from '@wellesley/router'
import { BookLock } from 'lucide-react'

export const RegistrationClosed = () => (
  <div className="mb-[96px] flex flex-col pt-xl">
    <div className="flex flex-col items-center gap-xxs">
      <BookLock size={64} className="text-gray-400" />
      <h1 className="text-lg font-semibold text-gray-900">
        Registration is closed
      </h1>
      <div className="text-base font-medium text-gray-500">
        It is closed by this server&apos;s admin, at least for now
      </div>
    </div>

    <div className="mt-m flex items-center justify-center py-m text-base font-medium">
      <span className="font-normal text-gray-700">Have an account?</span>
      <AppsLink to="/signin" className="ml-xxxs font-semibold text-blue-500">
        Sign in
      </AppsLink>
    </div>
  </div>
)
